
import { defineComponent } from 'vue'
import { Field } from 'vee-validate'

export default defineComponent({
  name: 'QOptionGroup',
  components: {
    Field
  }
})
